module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjExLjUiIHgyPSIxMS41IiB5Mj0iMjQiIHN0cm9rZT0iI0ZBQzUxNCIgc3Ryb2tlLWRhc2hhcnJheT0iNiA2Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/divider.svg
// module id = dTSR
// module chunks = 31